import { env } from '@/env';
import { beforeSend } from '@/services/datadog/scrub';

const DEFAULT_SITE = 'datadoghq.com';
const DD_SITES = [
  DEFAULT_SITE,
  'us3.datadoghq.com',
  'us5.datadoghq.com',
  'datadoghq.eu',
  'ddog-gov.com',
  'us2.ddog-gov.com',
  'ap1.datadoghq.com',
  'ap2.datadoghq.com',
] as const;
const SERVICE = 'access-registration';
const SESSION_PERSISTENCE = 'memory';

let initialized = false;

export const initDatadog = async (): Promise<void> => {
  const token = env.DD_CLIENT_TOKEN?.trim();
  if (initialized || !token) return;
  initialized = true;

  const configuredSite = env.DD_SITE?.trim();
  const site = DD_SITES.find((candidate) => candidate === configuredSite) ?? DEFAULT_SITE;

  const { datadogLogs } = await import('@datadog/browser-logs');
  datadogLogs.init({
    clientToken: token,
    site,
    service: SERVICE,
    env: env.MODE,
    version: env.APP_VERSION,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ['error'],
    sessionSampleRate: 100,
    telemetrySampleRate: 0,
    trackAnonymousUser: false,
    sessionPersistence: SESSION_PERSISTENCE,
    beforeSend,
  });
};
